import React from 'react';
import logoImage from '../assets/images/HolyLogo.png';

const HolyLogo = ({ className, style }) => {
  return (
    <img 
      src={logoImage} 
      alt="HolyHubs Logo" 
      className={className} 
      style={{ 
        width: '1em', 
        height: '1em', 
        verticalAlign: 'middle',
        ...style 
      }} 
    />
  );
};

export default HolyLogo; 